<div *ngIf="providerServices.length">
  <div class="card-deck">
    <h4>{{ 'Sellers.Bill_Payment.Services' | translate}}</h4>
      <div class="containerCard">
        <div (click)="displayBillerServiceForm(service)" *ngFor="let service of providerServices">
            <!-- <img
                style="width: 120px; height: 100px"
                [src]="service.Service.image"
              />
              <p class="text-nowrap">{{ service.Service.name }}</p> -->
            <button class="btn btnService" id="{{service.Service.name}}" (click)="activeButton(service)">{{service.Service.name}}</button>
      </div>
    </div>
  </div>
</div>
<div class="card-deck" *ngIf="service">
    <h4>{{ service.name.charAt(0).toUpperCase() + service.name.slice(1) }}</h4>
    <form *ngIf="BillerServiceForm" [formGroup]="BillerServiceForm">
      <ng-container *ngFor="let key of ObjectKeys; let i = index">
        <div [ngClass]="isFulLWidthLastController(i) ? 'col-12' : 'col-12'">
          <app-text [fieldObject]="controllers[key]" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(key)"></app-text>
        </div>
      </ng-container>

      <div *ngIf="!isInquirable" class=" mb-3">
        <input (keyup)="handleAmount($event)" min="1" required type="number" class="form-control"
          placeholder="Top up amount" aria-label="Amount" [value]="amountFormField?.defaultValue" [disabled]="amountFormField?.disabled"/>
        <div *ngIf="isAircharge" class="form-group mt-4 mb-2">
          <label for="totalAmount">
            <span class="h6 small bg-white text-muted pt-1 pl-2 pr-2">{{ 'Sellers.Bill_Payment.Total_amount' | translate}}</span>
          </label>
          <input class="form-control" id="totalAmount" type="number" placeholder="Total Amount"
            [(ngModel)]="totalAmount" readonly>
        </div>
      </div>


      <button type="button" class="btn mt-3" (click)="submit()" [disabled]="!BillerServiceForm.valid"
        *ngIf="isInquirable && !success">
        {{ 'Sellers.Bill_Payment.Submit' | translate}}
      </button>
      <button type="button" class="btn mt-3" (click)="handleNonInquirable()"
        [disabled]="!BillerServiceForm.valid && !amount" *ngIf="!isInquirable && !success && amount">
        {{ 'Sellers.Bill_Payment.Submit' | translate}}
      </button>
    </form>
    <div *ngIf="success" class="my-2">
      <div class="well" *ngIf="trxInquiryResponse">
		<div *ngIf="!priceTypeList">
          <h4>{{ 'Sellers.Bill_Payment.Your_bill' | translate}} :</h4>
          <h3>{{ trxInquiryResponse.data.amount | currency: "EGP" }}</h3>
        </div>
		<div *ngIf="priceTypeList">
          <h6>{{ 'Sellers.Bill_Payment.Select_Amount' | translate}}:</h6>
		  <select (change)="onSelectPrice($event)" class="form-select mt-4 mb-2">
			  <option *ngFor="let price of priceList" value={{price}}>{{price}}</option>
		  </select>
        </div>
      </div>
      <select (change)="handlePayChange($event)" class="form-select mt-4 mb-2" aria-label="Default select example">
        <option selected>{{ 'Sellers.Bill_Payment.Choose_Payment_Method' | translate}}</option>
        <option value="Balance">{{ 'Sellers.Bill_Payment.Pay_with_available_balance' | translate}}</option>
        <option value="Credit">{{ 'Sellers.Bill_Payment.pay_with_credit_card' | translate}}</option>
      </select>
      <button [disabled]="!payMethod" type="button" class="btn btn-success" (click)="ProceedToPay()">
        {{ 'Sellers.Bill_Payment.Proceed_To_Pay' | translate}}
      </button>
    </div>
    <span class="text-danger mt-3" *ngIf="errMsg">
      {{ errMsg }}
    </span>
</div>
